// Bloc foré steps shown progressively: every step up to the most advanced checked one, plus the
// next step to validate. Optional steps (outils spécifiques, cartouches non stockées) never
// block: they show up with the step before them and the next required step stays visible.
// Same rules as the API (helpers/etapesHelper.js).

function lastCheckedIndex(etapes) {
  for (let i = etapes.length - 1; i >= 0; i--) {
    if (etapes[i].isChecked) return i;
  }
  return -1;
}

export function visibleEtapes(etapes) {
  const list = etapes || [];
  const last = lastCheckedIndex(list);
  const next = list.findIndex((etape, i) => i > last && !etape.optionnelle);
  return next === -1 ? list : list.slice(0, next + 1);
}

// Steps 6 and 7 had no comment before the `sans_commentaire` flag existed
export function hasCommentaire(etape) {
  return !etape.sans_commentaire && etape.id !== 6 && etape.id !== 7;
}
